import { useState } from 'react'

import { ShareUnit, ShareUnitToggle } from '@digital-twins/deck-ui/plots/_shared'
import { DensityHistogramPlot, DensityHistogramPlotData } from '@digital-twins/deck-ui/plots/density-histogram'

import { FigurePanel, FigurePanelSections, FigureViewProps, useShareUnitLabels } from './figureViewShared'

import { DensityHistogramData } from '@digital-twins/slide-schemas/generated/plot-types'

/**
 * `density-histogram` on the survey tab (plots plan M, Wave 7 S2): the kind's
 * own plot component at its report size, the one quick study and the cards
 * draw. Shape only: bins share Python's edges and shares; the median, the
 * middle 50% band and the statistics are Python's, with the chrome words the
 * payload stamped in the viewer's UI language. A cut draws one titled plot
 * per group, each on the same edges.
 */

function renderHistogramPanel(panel: FigurePanel, locale: string, testIdPrefix: string, shareUnit: ShareUnit) {
  const data = panel.plot.data as unknown as DensityHistogramPlotData
  return (
    <DensityHistogramPlot
      data={data}
      props={{ size: 'report', fit: 'card', locale }}
      shareUnit={shareUnit}
      testIdPrefix={testIdPrefix}
    />
  )
}

export function DensityHistogramFigure(props: FigureViewProps) {
  const { panels, isCut, locale, initialShareUnit = 'percent' } = props

  const [shareUnit, setShareUnit] = useState<ShareUnit>(initialShareUnit)
  const shareUnitLabels = useShareUnitLabels()

  const testIdPrefix = 'figure-density-histogram'

  return (
    <div data-testid={testIdPrefix}>
      <div className="mb-3 flex justify-end">
        <ShareUnitToggle value={shareUnit} onChange={setShareUnit} labels={shareUnitLabels} testIdPrefix={`${testIdPrefix}-share-unit-`} />
      </div>
      <FigurePanelSections
        panels={panels}
        isCut={isCut}
        testIdPrefix={testIdPrefix}
        lowBaseLabel={(panel) => (panel.plot.data as unknown as DensityHistogramData).labels?.plot_low_base}
        renderPanel={(panel, index) =>
          renderHistogramPanel(panel, locale, isCut ? `${testIdPrefix}-${index}-plot` : `${testIdPrefix}-plot`, shareUnit)
        }
      />
    </div>
  )
}
